module.exports = __webpack_public_path__ + "img/down-arrow.48232869.svg";